(function () {
  'use strict';

  var locale = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
  var supportedLocales = ['de', 'en', 'fr', 'it'];
  if (supportedLocales.indexOf(locale) === -1) return;

  var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : locale === 'de' ? '/' : '/' + locale + '/';
  if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';

  var labels = {
    de: {
      'Search Results': 'Suchergebnisse',
      'Products': 'Produkte',
      'Categories': 'Kategorien',
      'Pages': 'Seiten',
      'Showing': 'Angezeigt',
      'results for': 'Ergebnisse für',
      'Nothing found for': 'Keine Treffer für',
      'Did you mean:': 'Meinten Sie:',
      'Your search': 'Ihre Suche',
      "didn't match any results. Look at": 'ergab keine Treffer. Entdecken Sie',
      'other items in our store': 'weitere Produkte in unserem Shop',
      'No categories were found': 'Keine Kategorien gefunden',
      'No pages were found': 'Keine Seiten gefunden',
      'Relevance': 'Relevanz',
      'Availability': 'Verfügbarkeit',
      'In Stock': 'Auf Lager',
      'Vendor': 'Marke',
      'Collections': 'Kollektionen',
      'Discount': 'Rabatt',
      'No discount': 'Kein Rabatt',
      'Price': 'Preis',
      'Price, CHF': 'Preis, CHF',
      'Product type': 'Produkttyp',
      'Product Type': 'Produkttyp',
      'Minimum value': 'Mindestwert',
      'Maximum value': 'Höchstwert',
      'Popular suggestions': 'Beliebte Suchvorschläge',
      'More': 'Mehr',
      'Rectangular': 'Rechteckig',
      'Round': 'Rund'
    },
    en: {},
    fr: {
      'Search Results': 'Résultats de recherche',
      'Products': 'Produits',
      'Categories': 'Catégories',
      'Pages': 'Pages',
      'Showing': 'Affichage',
      'results for': 'résultats pour',
      'Nothing found for': 'Aucun résultat pour',
      'Did you mean:': 'Vouliez-vous dire :',
      'Your search': 'Votre recherche',
      "didn't match any results. Look at": 'n’a donné aucun résultat. Découvrez',
      'other items in our store': 'd’autres produits dans notre boutique',
      'No categories were found': 'Aucune catégorie trouvée',
      'No pages were found': 'Aucune page trouvée',
      'Relevance': 'Pertinence',
      'Availability': 'Disponibilité',
      'In Stock': 'En stock',
      'Vendor': 'Marque',
      'Collections': 'Collections',
      'Discount': 'Remise',
      'No discount': 'Sans remise',
      'Price': 'Prix',
      'Price, CHF': 'Prix, CHF',
      'Product type': 'Type de produit',
      'Product Type': 'Type de produit',
      'Minimum value': 'Valeur minimale',
      'Maximum value': 'Valeur maximale',
      'Popular suggestions': 'Suggestions populaires',
      'More': 'Plus',
      'Sortiment': 'Assortiment',
      'Produktfamilie': 'Famille de produits',
      'Form': 'Forme',
      'Kurze Seite in cm': 'Petit côté en cm',
      'Lange Seite in cm': 'Grand côté en cm',
      'Profilstärke in cm': 'Épaisseur du profil en cm',
      'Preis': 'Prix',
      'Galerie-Keilrahmen': 'Châssis galerie',
      'Keilrahmen 2 cm': 'Châssis 2 cm',
      'Runde Keilrahmen': 'Châssis ronds',
      'Schattenfugenrahmen': 'Caisses américaines',
      'Zubehör': 'Accessoires',
      'Keilrahmen': 'Châssis',
      'Rechteckig': 'Rectangulaire',
      'Rund': 'Rond'
    },
    it: {
      'Search Results': 'Risultati della ricerca',
      'Products': 'Prodotti',
      'Categories': 'Categorie',
      'Pages': 'Pagine',
      'Showing': 'Visualizzazione',
      'results for': 'risultati per',
      'Nothing found for': 'Nessun risultato per',
      'Did you mean:': 'Forse cercavi:',
      'Your search': 'La tua ricerca',
      "didn't match any results. Look at": 'non ha prodotto risultati. Scopri',
      'other items in our store': 'altri prodotti nel nostro negozio',
      'No categories were found': 'Nessuna categoria trovata',
      'No pages were found': 'Nessuna pagina trovata',
      'Relevance': 'Pertinenza',
      'Availability': 'Disponibilità',
      'In Stock': 'Disponibile',
      'Vendor': 'Marca',
      'Collections': 'Collezioni',
      'Discount': 'Sconto',
      'No discount': 'Nessuno sconto',
      'Price': 'Prezzo',
      'Price, CHF': 'Prezzo, CHF',
      'Product type': 'Tipo di prodotto',
      'Product Type': 'Tipo di prodotto',
      'Minimum value': 'Valore minimo',
      'Maximum value': 'Valore massimo',
      'Popular suggestions': 'Suggerimenti popolari',
      'More': 'Altro',
      'Sortiment': 'Assortimento',
      'Produktfamilie': 'Famiglia di prodotti',
      'Form': 'Forma',
      'Kurze Seite in cm': 'Lato corto in cm',
      'Lange Seite in cm': 'Lato lungo in cm',
      'Profilstärke in cm': 'Spessore del profilo in cm',
      'Preis': 'Prezzo',
      'Galerie-Keilrahmen': 'Telaio galleria',
      'Keilrahmen 2 cm': 'Telaio 2 cm',
      'Runde Keilrahmen': 'Telai tondi',
      'Schattenfugenrahmen': 'Cornici a cassetta',
      'Zubehör': 'Accessori',
      'Keilrahmen': 'Telai',
      'Rechteckig': 'Rettangolare',
      'Rund': 'Tondo'
    }
  };
  var actions = {
    de: { add: 'In den Warenkorb', view: 'Produkt ansehen', select: 'Auswählen', configure: 'Konfigurieren', from: 'ab', stock: 'Verfügbar', sold: 'Zurzeit nicht verfügbar', adding: 'Wird hinzugefügt …', error: 'Nicht hinzugefügt. Bitte erneut versuchen.', filter: 'Filter', price: 'Preis', close: 'Schließen', results: 'Ergebnisse', for: 'für' },
    en: { add: 'Add to cart', view: 'View product', select: 'Choose options', configure: 'Configure', from: 'from', stock: 'Available', sold: 'Currently unavailable', adding: 'Adding …', error: 'Not added. Please try again.', filter: 'Filters', price: 'Price', close: 'Close', results: 'results', for: 'for' },
    fr: { add: 'Ajouter au panier', view: 'Voir le produit', select: 'Choisir', configure: 'Configurer', from: 'dès', stock: 'Disponible', sold: 'Indisponible actuellement', adding: 'Ajout en cours …', error: 'Non ajouté. Veuillez réessayer.', filter: 'Filtres', price: 'Prix', close: 'Fermer', results: 'résultats', for: 'pour' },
    it: { add: 'Aggiungi al carrello', view: 'Vedi prodotto', select: 'Scegli', configure: 'Configura', from: 'da', stock: 'Disponibile', sold: 'Al momento non disponibile', adding: 'Aggiunta …', error: 'Non aggiunto. Riprova.', filter: 'Filtri', price: 'Prezzo', close: 'Chiudi', results: 'risultati', for: 'per' }
  };
  var productCache = new Map();
  var committedPageUrl = null;
  try { committedPageUrl = new URL(window.location.href); } catch (error) { /* Not a storefront URL. */ }
  var exactSingleCopy = { de: 'exakt passendes Produkt', en: 'exactly matching product', fr: 'produit au format exact', it: 'prodotto del formato esatto' };
  var interfaceCopy = {
de: { placeholder: 'Was suchst du?', back: 'Zurück', clear: 'Löschen', dialog: 'Suchvorschläge', loading: 'Passende Produkte werden geladen …', loadError: 'Die passenden Produkte konnten nicht vollständig geladen werden. Bitte erneut versuchen.', retry: 'Erneut versuchen', unavailableTitle: 'Produktdetails werden geladen', failedTitle: 'Produktdetails nicht verfügbar', minimum: 'Preis ab', maximum: 'Preis bis', apply: 'Anwenden', reset: 'Zurücksetzen', sort: 'Sortieren', exact: 'exakt passende Produkte', empty: 'Keine Standardprodukte in diesem Format. Passende Konfiguratoren findest du unten.', emptyPrice: 'Kein passendes Produkt in dieser Preisspanne.', options: 'passende Varianten', relevance: 'Relevanz', ascending: 'Preis aufsteigend', descending: 'Preis absteigend', titleAsc: 'Titel: A–Z', titleDesc: 'Titel: Z–A', priceError: 'Bitte gültige Preise eingeben; der Mindestpreis darf nicht über dem Höchstpreis liegen.' },
    en: { placeholder: 'What are you looking for?', back: 'Back', clear: 'Clear', dialog: 'Search suggestions', loading: 'Loading matching products …', loadError: 'The matching products could not be fully loaded. Please try again.', retry: 'Try again', unavailableTitle: 'Loading product details', failedTitle: 'Product details unavailable', minimum: 'Price from', maximum: 'Price to', apply: 'Apply', reset: 'Reset', sort: 'Sort by', exact: 'exactly matching products', empty: 'No standard products in this size. Find suitable configurators below.', emptyPrice: 'No matching products in this price range.', options: 'matching options', relevance: 'Relevance', ascending: 'Price: low to high', descending: 'Price: high to low', titleAsc: 'Title: A–Z', titleDesc: 'Title: Z–A', priceError: 'Enter valid prices; the minimum must not exceed the maximum.' },
    fr: { placeholder: 'Que cherchez-vous ?', back: 'Retour', clear: 'Effacer', dialog: 'Suggestions de recherche', loading: 'Chargement des produits correspondants …', loadError: 'Les produits correspondants n’ont pas pu être chargés complètement. Veuillez réessayer.', retry: 'Réessayer', unavailableTitle: 'Chargement du produit', failedTitle: 'Détails du produit indisponibles', minimum: 'Prix minimum', maximum: 'Prix maximum', apply: 'Appliquer', reset: 'Réinitialiser', sort: 'Trier par', exact: 'produits au format exact', empty: 'Aucun produit standard à ce format. Retrouvez les configurateurs adaptés ci-dessous.', emptyPrice: 'Aucun produit correspondant dans cette gamme de prix.', options: 'variantes correspondantes', relevance: 'Pertinence', ascending: 'Prix croissant', descending: 'Prix décroissant', titleAsc: 'Titre : A–Z', titleDesc: 'Titre : Z–A', priceError: 'Saisissez des prix valides ; le minimum ne doit pas dépasser le maximum.' },
    it: { placeholder: 'Cosa stai cercando?', back: 'Indietro', clear: 'Cancella', dialog: 'Suggerimenti di ricerca', loading: 'Caricamento dei prodotti corrispondenti …', loadError: 'Non è stato possibile caricare tutti i prodotti corrispondenti. Riprova.', retry: 'Riprova', unavailableTitle: 'Caricamento del prodotto', failedTitle: 'Dettagli del prodotto non disponibili', minimum: 'Prezzo minimo', maximum: 'Prezzo massimo', apply: 'Applica', reset: 'Reimposta', sort: 'Ordina per', exact: 'prodotti del formato esatto', empty: 'Nessun prodotto standard in questo formato. Trovi i configuratori adatti qui sotto.', emptyPrice: 'Nessun prodotto corrispondente in questa fascia di prezzo.', options: 'varianti corrispondenti', relevance: 'Pertinenza', ascending: 'Prezzo crescente', descending: 'Prezzo decrescente', titleAsc: 'Titolo: A–Z', titleDesc: 'Titolo: Z–A', priceError: 'Inserisci prezzi validi; il minimo non può superare il massimo.' }
  };
  var sortLabels = {
    de: ['Titel: A–Z', 'Titel: Z–A', 'Neueste zuerst', 'Älteste zuerst', 'Preis aufsteigend', 'Preis absteigend', 'Rabatt absteigend', 'Bestseller'],
    fr: ['Titre : A–Z', 'Titre : Z–A', 'Plus récents', 'Plus anciens', 'Prix croissant', 'Prix décroissant', 'Remise décroissante', 'Meilleures ventes'],
    it: ['Titolo: A–Z', 'Titolo: Z–A', 'Più recenti', 'Meno recenti', 'Prezzo crescente', 'Prezzo decrescente', 'Sconto decrescente', 'Più venduti']
  };
  ['Title: A-Z', 'Title: Z-A', 'Date: New to Old', 'Date: Old to New', 'Price: Low to High', 'Price: High to Low', 'Discount: High to Low', 'Bestselling'].forEach(function (key, index) {
    ['de', 'fr', 'it'].forEach(function (language) { labels[language][key] = sortLabels[language][index]; });
  });
  var scanTimer = null;
  var forbiddenFilters = [
    'tags',
    'tag',
    'vendor',
    'brand',
    'marke',
    'marque',
    'marca',
    'hersteller',
    'fabricant',
    'produttore',
    'collections',
    'collection',
    'kollektionen',
    'collezioni',
    'product type',
    'produkttyp',
    'type de produit',
    'tipo di prodotto',
    'discount',
    'rabatt',
    'remise',
    'réduction',
    'sconto',
    'availability',
    'verfügbarkeit',
    'disponibilité',
    'disponibilità'
  ];

  function productHandle(link) {
    try {
      var path = new URL(link.href, window.location.origin).pathname;
      var match = path.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function plainText(html) {
    var template = document.createElement('template');
    template.innerHTML = String(html || '').replace(/<\/[^>]+>/g, '$& ');
    return (template.content.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/\s+([,.;:!?])/g, '$1')
      .trim();
  }

  function localizedHandleFor(handle) {
    var routes = window.FleurySearchConfig && window.FleurySearchConfig.productRoutes || {};
    var source = routes[handle];
    if (!source) Object.keys(routes).some(function (key) {
      if (Object.keys(routes[key]).some(function (language) { return routes[key][language] === handle; })) { source = routes[key]; handle = key; return true; }
      return false;
    });
    return source && source[locale] || handle;
  }

  function localizedProduct(handle) {
    var targetHandle = localizedHandleFor(handle);
    if (productCache.has(targetHandle)) return productCache.get(targetHandle);
    var request = fetch(rootUrl + 'products/' + encodeURIComponent(targetHandle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Localized product request failed');
      return response.json();
    }).then(function (product) {
      if (!product || typeof product.title !== 'string' || !product.title.trim() || !Array.isArray(product.variants)) throw new Error('Incomplete localized product');
      return product;
    }).catch(function () {
      // Keep the failure cached for this page visit. An observer must not turn
      // an unavailable translation or transient HTTP failure into a retry loop.
      return null;
    });
    productCache.set(targetHandle, request);
    return request;
  }

  function localizeCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var handle = link && productHandle(link);
    if (!handle) return;
    if (card.closest('[data-fa-exact-results]')) return;
    var query = searchQuery(card);
    var targetHandle = localizedHandleFor(handle);
    if ((card.dataset.faLocalization === locale || card.dataset.faLocalization === 'failed') && card.dataset.faQuery === query && card.dataset.faHandle === handle) return;
    if (card.dataset.faLocalization === 'loading' && card.dataset.faPendingHandle === targetHandle && card.dataset.faPendingQuery === query) return;
    var requestId = Number(card.dataset.faLocalizationRequest || 0) + 1;
    card.dataset.faLocalizationRequest = String(requestId);
    card.dataset.faPendingHandle = targetHandle;
    card.dataset.faPendingQuery = query;
    card.dataset.faLocalization = 'loading';
    card.setAttribute('aria-busy', 'true');
    card.setAttribute('aria-label', interfaceCopy[locale].unavailableTitle);
    link.setAttribute('aria-label', interfaceCopy[locale].unavailableTitle);
    card.lang = locale;
    setText(card.querySelector('.snize-title'), interfaceCopy[locale].unavailableTitle);
    setText(card.querySelector('.snize-description'), '');
    var loadingImage = card.querySelector('img');
    if (loadingImage) loadingImage.alt = '';
    if (card.closest('#snize_results')) {
      delete card.dataset.faCardReady;
      card.querySelectorAll('.fa-search-card-meta, .fa-search-card-stock, .fa-search-card-action, .fa-search-card-error').forEach(function (node) { node.remove(); });
      var fallbackUrl = rootUrl + 'products/' + encodeURIComponent(targetHandle);
      // Until Shopify confirms the variant and its price, expose only a plain
      // product link. Never leave Searchanise's first-variant action available.
      card.querySelectorAll('a[href*="/products/"]').forEach(function (item) { item.href = fallbackUrl; });
      var fallback = document.createElement('a');
      fallback.className = 'fa-search-card-action';
      fallback.href = fallbackUrl;
      fallback.textContent = actions[locale].view;
      card.appendChild(fallback);
    }

    localizedProduct(handle).then(function (product) {
      if (card.dataset.faLocalizationRequest !== String(requestId)) return;
      if (searchQuery(card) !== query || localizedHandleFor(productHandle(link)) !== targetHandle) {
        card.dataset.faLocalization = '';
        scheduleScan();
        return;
      }
      card.setAttribute('aria-busy', 'false');
      if (!product) {
        setText(card.querySelector('.snize-title'), interfaceCopy[locale].failedTitle);
        card.setAttribute('aria-label', interfaceCopy[locale].failedTitle);
        link.setAttribute('aria-label', interfaceCopy[locale].failedTitle);
        card.dataset.faLocalization = 'failed';
        card.dataset.faQuery = query;
        card.dataset.faHandle = productHandle(link);
        return;
      }

      var title = localizedProductTitle(product);
      var titleElement = card.querySelector('.snize-title');
      var descriptionElement = card.querySelector('.snize-description');
      var image = card.querySelector('img');
      var description = plainText(product.description);

      if (title && titleElement) titleElement.textContent = title;
      if (descriptionElement && description) {
        descriptionElement.textContent = description.length > 260 ? description.slice(0, 257).trimEnd() + '…' : description;
      }
      if (title && link) link.setAttribute('aria-label', title);
      if (title) card.setAttribute('aria-label', title);
      if (title && image) image.alt = title;

      var productUrl = rootUrl + 'products/' + encodeURIComponent(product.handle || handle);
      var resolver = window.FleurySearchFormatIntent;
      if (resolver && resolver.resolveProductHandle) {
        var localizedHandle = resolver.resolveProductHandle({ handle: product.handle || handle }, locale);
        if (localizedHandle) productUrl = rootUrl + 'products/' + encodeURIComponent(localizedHandle);
      }
      card.querySelectorAll('a[href*="/products/"]').forEach(function (item) {
        var variant = new URL(item.href, window.location.origin).searchParams.get('variant');
        item.href = productUrl + (variant ? '?variant=' + encodeURIComponent(variant) : '');
      });

      if (card.closest('#snize_results')) enhanceCard(card, product, productUrl, query);

      var addButton = card.querySelector('.snize-add-to-cart-button');
      var viewButton = card.querySelector('.snize-view-product-button');
      if (addButton) addButton.textContent = actions[locale].add;
      if (viewButton) viewButton.textContent = actions[locale].view;
      card.lang = locale;
      card.dataset.faLocalization = locale;
      card.dataset.faQuery = query;
      card.dataset.faHandle = productHandle(link);
    });
  }

  function searchQuery(node) {
    var parser = window.FleurySearchFormatIntent;
    if (node && parser && parser.queryForNode) return parser.queryForNode(node, window);
    if (node && node.closest('#snize-instant-search-results')) {
      var input = document.activeElement;
      if (input && input.matches('input.snize-input-style, input[type="search"], input[name="q"], input[data-search-input]')) return input.value || '';
      input = document.querySelector('#snize-mobile-search-input') || document.querySelector('input[type="search"], input[name="q"], input[data-search-input]');
      return input && input.value || '';
    }
    return new URL(window.location.href).searchParams.get('q') || '';
  }

  function preserveCommittedFormatQuery() {
    var parser = window.FleurySearchFormatIntent;
    if (!committedPageUrl || !parser || !parser.parseFormatIntent || !document.querySelector('[data-fa-search-page]')) return;
    var original = committedPageUrl.searchParams.get('q') || '';
    if (!parser.parseFormatIntent(original)) return;
    var current = new URL(window.location.href);
    if (current.pathname !== committedPageUrl.pathname || current.searchParams.get('q') === original) return;
    // Searchanise may remove dimensions while autocorrecting a text query.
    // Exact-size results own this committed query, not that fuzzy correction.
    current.searchParams.set('q', original);
    if (window.history && window.history.replaceState) window.history.replaceState(window.history.state, '', current.href);
  }

  function installFormatQueryHistoryGuard() {
    if (!window.history || window.__faFormatQueryHistoryGuard || !document.querySelector('[data-fa-search-page]')) return;
    window.__faFormatQueryHistoryGuard = true;
    ['pushState', 'replaceState'].forEach(function (name) {
      var originalMethod = window.history[name];
      if (typeof originalMethod !== 'function') return;
      window.history[name] = function (state, title, destination) {
        var parser = window.FleurySearchFormatIntent;
        var literal = committedPageUrl && committedPageUrl.searchParams.get('q');
        if (destination !== undefined && destination !== null && literal && parser && parser.parseFormatIntent(literal)) {
          try {
            var target = new URL(destination, window.location.href);
            if (target.origin === committedPageUrl.origin && target.pathname === committedPageUrl.pathname) {
              target.searchParams.set('q', literal);
              destination = target.href;
            }
          } catch (error) { /* Leave invalid destinations to the native method. */ }
        }
        return originalMethod.call(this, state, title, destination);
      };
    });
  }

  function onSearchPopstate(event) {
    // Browser back/forward is an explicit navigation and establishes a new query.
    // A synthetic Searchanise notification is not a new customer search.
    if (!event || event.isTrusted !== false) committedPageUrl = new URL(window.location.href);
    scheduleScan();
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function selectedFormatVariant(product, query) {
    var parser = window.FleurySearchFormatIntent;
    if (!parser) return null;
    var intent = parser.parseFormatIntent(query === undefined ? searchQuery() : query);
    if (!intent) return null;
    var matches = (product.variants || []).filter(function (variant) {
      return [variant.title].concat(variant.options || []).some(function (value) {
        var format = parser.parseFormatIntent(String(value || ''));
        return format && format.kind === intent.kind && format.key === intent.key;
      });
    });
    return matches.length === 1 ? matches[0] : null;
  }

  function money(value) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'CHF';
    return new Intl.NumberFormat(locale + '-CH', { style: 'currency', currency: currency }).format(Number(value) / 100);
  }

  function localizedProductTitle(product) {
    var title = String(product.title || '').trim();
    // The current source translation retains this German round suffix in all
    // three secondary languages. Normalize only that known suffix, not titles.
    return title.replace(/\(rund\)/gi, { de: '(rund)', en: '(round)', fr: '(rond)', it: '(tondo)' }[locale]);
  }

  function configuratorTarget(product, query) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    var id = tags.indexOf('massprodukt-canvas') !== -1 || tags.indexOf('canvas-configurator') !== -1 ? 'canvas'
      : tags.indexOf('massprodukt-shadow_frame') !== -1 || tags.indexOf('rahmen-konfigurator') !== -1 ? 'shadow'
        : tags.indexOf('massprodukt-picture_frame') !== -1 || tags.indexOf('bilderrahmen-konfigurator') !== -1 ? 'picture'
          : tags.indexOf('passepartout-configurator') !== -1 || tags.indexOf('massprodukt-passepartout') !== -1 ? 'mat' : null;
    var registry = window.FleurySearchConfigurators;
    var parser = window.FleurySearchFormatIntent;
    if (!id || !registry) return null;
    var intent = parser && (parser.parseFormatIntent(query === undefined ? searchQuery() : query) || parser.parseFormatIntent(product.title));
    return registry.buildUrl(id, intent, window.FleurySearchFormatCatalog, window.FleurySearchConfig);
  }

  function enhanceCard(card, product, productUrl, query, exactVariants) {
    card.querySelectorAll('.fa-search-card-meta, .fa-search-card-stock, .fa-search-card-action, .fa-search-card-error').forEach(function (node) { node.remove(); });
    var copy = actions[locale];
    var variants = exactVariants || product.variants || [];
    var purchasable = variants.filter(function (item) { return item.available; });
    var pricedVariants = exactVariants && purchasable.length ? purchasable : variants;
    if (exactVariants) pricedVariants = pricedVariants.slice().sort(function (left, right) { return Number(left.price) - Number(right.price); });
    var variant = exactVariants ? (pricedVariants.length === 1 ? pricedVariants[0] : null) : selectedFormatVariant(product, query) || (variants.length === 1 ? variants[0] : null);
    var customTarget = exactVariants ? null : configuratorTarget(product, query);
    var available = variant ? variant.available : exactVariants ? purchasable.length > 0 : product.available;
    var content = card.querySelector('.snize-overhidden') || card;
    var price = card.querySelector('.snize-price');
    var minimumPrice = exactVariants ? Math.min.apply(Math, pricedVariants.map(function (item) { return Number(item.price); })) : product.price_min || product.price;
    if (price) setText(price, (variant ? '' : variants.length > 1 ? copy.from + ' ' : '') + money(variant ? variant.price : minimumPrice));
    if (price && customTarget) setText(price, { de: 'Preis im Konfigurator', en: 'Price in configurator', fr: 'Prix dans le configurateur', it: 'Prezzo nel configuratore' }[locale]);
    card.querySelectorAll('.snize-discounted-price, .snize-save-price, .snize-discount-label').forEach(function (el) { el.hidden = true; });
    var meta = document.createElement('span');
    meta.className = 'fa-search-card-meta';
    meta.textContent = variant && variant.title !== 'Default Title' ? variant.title : exactVariants && variants.length > 1 ? variants.map(function (item) { return item.title; }).filter(function (title, index, all) { return title && title !== 'Default Title' && all.indexOf(title) === index; }).join(' · ') : '';
    if (meta.textContent) content.appendChild(meta);
    var stock = document.createElement('span');
    stock.className = 'fa-search-card-stock';
    stock.dataset.available = String(Boolean(available));
    stock.textContent = available ? copy.stock : copy.sold;
    content.appendChild(stock);
    var action = document.createElement(!customTarget && variant && available ? 'button' : 'a');
    action.className = 'fa-search-card-action';
    action.textContent = customTarget ? copy.configure : variant && available ? copy.add : variants.length > 1 ? copy.select : copy.view;
    if (action.tagName === 'A') action.href = customTarget ? customTarget.url : productUrl + (variant ? '?variant=' + variant.id : exactVariants && pricedVariants.length ? '?variant=' + pricedVariants[0].id : '');
    else {
      action.type = 'button';
      action.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (action.disabled) return;
        action.disabled = true;
        setText(action, copy.adding);
        fetch(rootUrl + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
          .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
          .then(function () { try { if (window.FleurySearchAnalytics) window.FleurySearchAnalytics.cartAdded(card, variant.id); } catch (e) { /* Measurement never interrupts shopping. */ } window.location.assign(rootUrl + 'cart'); })
          .catch(function () { action.disabled = false; setText(action, copy.add); var error = card.querySelector('.fa-search-card-error'); if (!error) { error = document.createElement('span'); error.className = 'fa-search-card-error'; error.setAttribute('role', 'alert'); card.appendChild(error); } setText(error, copy.error); });
      });
    }
    if (variant || exactVariants && pricedVariants.length) card.querySelectorAll('a.snize-view-link').forEach(function (link) { link.href = productUrl + '?variant=' + (variant || pricedVariants[0]).id; });
    card.appendChild(action);
    card.dataset.faCardReady = 'true';
  }

  function localizeText(root) {
    var dictionary = labels[locale];
    var partialKeys = [
      "didn't match any results. Look at",
      'other items in our store',
      'Nothing found for',
      'results for',
      'Did you mean:',
      'Your search'
    ];
    if (!root || !dictionary || !Object.keys(dictionary).length) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue || '';
      if (value.indexOf('[search_string]') !== -1) { value = value.split('[search_string]').join(searchQuery(root)); node.nodeValue = value; }
      var trimmed = value.trim();
      if (Object.prototype.hasOwnProperty.call(dictionary, trimmed)) {
        var translated = value.replace(trimmed, dictionary[trimmed]);
        if (translated !== value) node.nodeValue = translated;
        continue;
      }
      partialKeys.forEach(function (key) {
        if (!dictionary[key] || dictionary[key] === key || node.nodeValue.indexOf(key) === -1) return;
        node.nodeValue = node.nodeValue.split(key).join(dictionary[key]);
      });
    }
  }

  function localizeInstantActions() {
    var copy = interfaceCopy[locale];
    document.querySelectorAll('#snize-instant-search-results #sr-summary').forEach(function (status) {
      var query = searchQuery(status);
      var message = { de: 'Suchvorschläge aktualisiert für', en: 'Search suggestions updated for', fr: 'Suggestions actualisées pour', it: 'Suggerimenti aggiornati per' }[locale];
      setText(status, query ? message + ' „' + query + '“.' : '');
    });
    document.querySelectorAll('#snize-products-label').forEach(function (heading) {
      setText(heading, { de: 'Produkte', en: 'Products', fr: 'Produits', it: 'Prodotti' }[locale]);
    });
    document.querySelectorAll('#snize-instant-search-results').forEach(function (popup) { popup.setAttribute('aria-label', copy.dialog); });
    document.querySelectorAll('#snize-mobile-search-input').forEach(function (input) { input.placeholder = copy.placeholder; input.setAttribute('aria-label', copy.placeholder); });
    document.querySelectorAll('#snize-instant-search-results [aria-label="Back"], #snize-instant-search-results .snize-mobile-back-button').forEach(function (button) { button.setAttribute('aria-label', copy.back); });
    document.querySelectorAll('#snize-instant-search-results [aria-label="Clear"], #snize-instant-search-results .snize-mobile-clear-button').forEach(function (button) { button.setAttribute('aria-label', copy.clear); });
    document.querySelectorAll('#snize-instant-search-results [aria-label="Close"]').forEach(function (button) { button.setAttribute('aria-label', actions[locale].close); });
    // Analytics-derived popular queries have no reliable language identity.
    // They are intentionally removed, including their heading and sales CTA.
    document.querySelectorAll('.snize-popular-suggestions-text, .snize-popular-suggestions-container, .snize-popular-suggestions-view-all-products-text, .snize-popular-suggestions, #snize-ac-items-container-1').forEach(function (node) {
      if (!node.hidden) node.hidden = true;
      if (node.getAttribute('aria-hidden') !== 'true') node.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('#snize-instant-search-results .snize-nothing-found-text').forEach(function (node) {
      var query = searchQuery(node);
      var text = { de: 'Keine Ergebnisse für', en: 'No results for', fr: 'Aucun résultat pour', it: 'Nessun risultato per' }[locale] + ' „' + query + '“.';
      setText(node, text);
    });
    document.querySelectorAll('#snize-instant-search-results .snize-view-all-link').forEach(function (button) {
      var count = (button.textContent || '').match(/\d+/);
      if (!count) return;
      var text = locale === 'fr'
        ? 'Voir les ' + count[0] + ' résultats'
        : locale === 'it'
          ? 'Vedi tutti i ' + count[0] + ' risultati'
          : locale === 'en' ? 'View all ' + count[0] + ' results' : 'Alle ' + count[0] + ' Treffer ansehen';
      button.setAttribute('aria-label', text);
      setText(button, text);
    });
  }

  function normalizeFilterName(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[:：]\s*$/, '')
      .trim();
  }

  function hideForbiddenFilters() {
    document.querySelectorAll('.snize-product-filters-block').forEach(function (block) {
      var heading = block.querySelector(
        '.snize-product-filters-title, .snize-product-filters-block-title, h3, h4, .snize-filter-title'
      );
      var name = normalizeFilterName(heading && heading.textContent);
      if (!name || forbiddenFilters.indexOf(name) === -1) return;
      block.hidden = true;
      block.setAttribute('aria-hidden', 'true');
      block.dataset.faHiddenFilter = name;
    });

    document.querySelectorAll('.snize-modal .snize-product-filters-header').forEach(function (header) {
      var heading = header.querySelector('.snize-product-filters-title');
      var name = normalizeFilterName(heading && heading.textContent);
      if (forbiddenFilters.indexOf(name) === -1) return;
      header.hidden = true;
      var container = header.nextElementSibling;
      if (container && container.classList.contains('snize-product-filter-container')) container.hidden = true;
    });

    document.querySelectorAll(
      '.snize-product-filters-block li, .snize-filters-sidebar li, .snize-selected-filters li, .snize-modal .snize-product-filters-list li'
    ).forEach(function (item) {
      var value = normalizeFilterName(item.textContent);
      if (!/(?:^|[\s_-])(searchanise|internal|ops)[_: -]/i.test(value) && value !== 'bg-removed') return;
      item.hidden = true;
      item.setAttribute('aria-hidden', 'true');
    });
  }

  function hideContentTabs() {
    document.querySelectorAll(
      '.snize-main-panel-controls li, .snize-search-results-tabs li, .snize-search-results-tabs a'
    ).forEach(function (item) {
      var name = normalizeFilterName(item.textContent).replace(/\s+\d+$/, '');
      if (['categories', 'kategorien', 'catégories', 'categorie', 'pages', 'seiten', 'pagine'].indexOf(name) === -1) {
        return;
      }
      var target = item.tagName === 'LI' ? item : item.closest('li') || item;
      target.hidden = true;
      target.setAttribute('aria-hidden', 'true');
    });
  }

  function enhanceToolbar() {
    var results = document.getElementById('snize_results');
    if (!results) return;
    var panel = results.querySelector('.snize-main-panel');
    var sidebar = results.querySelector('.snize-filters-sidebar');
    var summary = results.querySelector('.snize-search-results-header');
    var countNode = results.querySelector('.snize-products-tab-total');
    var count = countNode ? Number(countNode.textContent.replace(/[^0-9]/g, '')) : NaN;
    if (!Number.isFinite(count) && summary) {
      var bold = summary.querySelector('b');
      if (bold) count = Number(bold.textContent.replace(/[^0-9]/g, ''));
    }
    if (panel && Number.isFinite(count)) {
      var text = new Intl.NumberFormat(locale).format(count) + ' ' + actions[locale].results;
      if (searchQuery()) text += ' ' + actions[locale].for + ' „' + searchQuery() + '“';
      var ownSummary = panel.querySelector('.fa-search-results-summary');
      if (!ownSummary) { ownSummary = document.createElement('p'); ownSummary.className = 'fa-search-results-summary'; ownSummary.setAttribute('aria-live', 'polite'); panel.insertBefore(ownSummary, panel.firstChild); }
      setText(ownSummary, text);
    }
    // Keep the native sorting control under Searchanise's original parent:
    // its option actions use delegated events there. CSS aligns it visually
    // with our toolbar without changing the widget's DOM ownership.
    if (!panel || !sidebar) return;
    var filters = Array.prototype.filter.call(sidebar.querySelectorAll('.snize-product-filters-block'), function (block) { return !block.hidden && !block.dataset.faHiddenFilter && block.style.display !== 'none'; });
    var mode = filters.length === 0 ? 'none' : filters.length === 1 && /price|preis|prix|prezzo/i.test(filters[0].id + ' ' + filters[0].textContent) ? 'price' : 'multiple';
    results.dataset.faFilterMode = mode;
    sidebar.id = 'fa-search-filters';
    var toggle = panel.querySelector('[data-fa-filter-toggle]');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'fa-search-filter-toggle';
      toggle.dataset.faFilterToggle = '';
      toggle.setAttribute('aria-controls', sidebar.id);
      toggle.setAttribute('aria-expanded', 'false');
      panel.appendChild(toggle);
      toggle.addEventListener('click', function () { setFiltersOpen(results, results.dataset.faFiltersOpen !== 'true'); });
    }
    toggle.hidden = mode === 'none';
    setText(toggle, (mode === 'price' ? actions[locale].price : actions[locale].filter) + ' ⌄');
    if (!sidebar.querySelector('[data-fa-filter-close]')) {
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'fa-search-filter-close';
      close.dataset.faFilterClose = '';
      close.textContent = actions[locale].close + ' ×';
      sidebar.insertBefore(close, sidebar.firstChild);
      close.addEventListener('click', function () { setFiltersOpen(results, false); });
    }
    if (!results.querySelector('.fa-search-filter-backdrop')) {
      var backdrop = document.createElement('button');
      backdrop.type = 'button';
      backdrop.className = 'fa-search-filter-backdrop';
      backdrop.tabIndex = -1;
      backdrop.setAttribute('aria-label', actions[locale].close);
      backdrop.addEventListener('click', function () { setFiltersOpen(results, false); });
      results.appendChild(backdrop);
    }
    if (!results.dataset.faFilterEvents) {
      results.dataset.faFilterEvents = 'true';
      results.addEventListener('keydown', function (event) {
        if (results.dataset.faFiltersOpen !== 'true') return;
        if (event.key === 'Escape') { event.preventDefault(); setFiltersOpen(results, false); }
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.filter.call(sidebar.querySelectorAll('button, input:not([type=hidden]), a[href], [tabindex="0"]'), function (item) { return item.getClientRects().length && !item.disabled; });
        if (!focusable.length) return;
        if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
        else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
      });
    }
  }

  function setFiltersOpen(results, open) {
    results.dataset.faFiltersOpen = String(open);
    var toggle = results.querySelector('[data-fa-filter-toggle]');
    var sidebar = results.querySelector('.snize-filters-sidebar');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (sidebar) {
      if (open) {
        sidebar.setAttribute('role', 'dialog');
        sidebar.setAttribute('aria-label', actions[locale].filter);
        var close = sidebar.querySelector('[data-fa-filter-close]');
        if (close) close.focus();
      } else sidebar.removeAttribute('role');
    }
    if (!open && toggle) toggle.focus();
  }

  // Format results deliberately do not reuse Searchanise's product-level
  // price filtering or fuzzy paging: all exact variants must be considered.
  var exactState = null;
  var exactRequest = 0;
  var exactSortValues = ['relevance', 'price-asc', 'price-desc', 'title-asc', 'title-desc'];

  function sameFormat(value, intent) {
    var parser = window.FleurySearchFormatIntent;
    var parsed = parser && parser.parseFormatIntent(String(value || ''));
    return parsed && parsed.kind === intent.kind && parsed.key === intent.key;
  }

  function exactCandidates(catalog, intent) {
    if (!catalog || !intent) return [];
    var mapName = intent.kind === 'round' ? 'rounds' : 'rectangles';
    var rows = catalog.candidates && catalog.candidates[mapName] && catalog.candidates[mapName][intent.key];
    if (!rows) {
      var legacy = catalog[mapName] && catalog[mapName][intent.key];
      rows = Array.isArray(legacy) ? legacy : legacy ? Object.keys(legacy).reduce(function (all, family) {
        return all.concat((legacy[family] || []).map(function (item) { return Object.assign({ family: family }, item); }));
      }, []) : [];
    }
    var grouped = {};
    rows.forEach(function (item) {
      if (!item.handle) return;
      var handle = localizedHandleFor(item.handle);
      var target = grouped[handle] || (grouped[handle] = { handle: item.handle, family: item.family, variantIds: [] });
      (item.variantIds || (item.variantId ? [item.variantId] : [])).forEach(function (id) {
        if (target.variantIds.indexOf(String(id)) === -1) target.variantIds.push(String(id));
      });
    });
    return Object.keys(grouped).map(function (key) { return grouped[key]; });
  }

  function matchingExactVariants(product, candidate, intent) {
    if (!product || configuratorTarget(product, '')) return [];
    var titleMatches = sameFormat(product.title, intent);
    var parser = window.FleurySearchFormatIntent;
    return (product.variants || []).filter(function (variant) {
      var values = [variant.title].concat(variant.options || []);
      var parsed = values.map(function (value) { return parser && parser.parseFormatIntent(String(value || '')); }).filter(Boolean);
      var matches = parsed.length ? parsed.some(function (format) { return format.kind === intent.kind && format.key === intent.key; }) : titleMatches || (candidate.variantIds || []).indexOf(String(variant.id)) !== -1;
      // A catalog variant ID is an explicit current size association, needed
      // for round diameter-only options and product-level format metafields.
      if (!matches) return false;
      // An incomplete matching variant invalidates hydration of the complete
      // candidate set. Never coerce null/empty prices into free products or
      // silently drop a broken variant while claiming an exact result count.
      var priceType = typeof variant.price;
      if ((priceType !== 'number' && !(priceType === 'string' && /^\d+$/.test(variant.price))) || !Number.isInteger(Number(variant.price)) || Number(variant.price) < 0 || !variant.id || typeof variant.available !== 'boolean') throw new Error('Incomplete exact variant');
      return true;
    });
  }

  function readExactControls(url) {
    var params = new URL(url).searchParams;
    function price(key) {
      var raw = params.get(key);
      if (raw === null || raw.trim() === '') return null;
      if (!/^\d+(?:[.,]\d{1,2})?$/.test(raw)) return NaN;
      return Math.round(Number(raw.replace(',', '.')) * 100);
    }
    var minimum = price('fa_price_min');
    var maximum = price('fa_price_max');
    var valid = (minimum === null || Number.isFinite(minimum)) && (maximum === null || Number.isFinite(maximum)) && (minimum === null || maximum === null || minimum <= maximum);
    var sort = params.get('fa_sort') || 'relevance';
    return { minimum: minimum, maximum: maximum, valid: valid, sort: exactSortValues.indexOf(sort) === -1 ? 'relevance' : sort };
  }

  function filterExactProducts(products, controls) {
    if (!controls.valid) return [];
    var filtered = products.map(function (entry) {
      var variants = entry.variants.filter(function (variant) {
        var price = Number(variant.price);
        return (controls.minimum === null || price >= controls.minimum) && (controls.maximum === null || price <= controls.maximum);
      });
      if (!variants.length) return null;
      var available = variants.filter(function (variant) { return variant.available; });
      return { product: entry.product, variants: variants, family: entry.family, available: Boolean(available.length), price: Math.min.apply(Math, (available.length ? available : variants).map(function (variant) { return Number(variant.price); })) };
    }).filter(Boolean);
    var priority = null;
    var registry = window.FleurySearchConfigurators;
    if (controls.query && registry && registry.recommend) priority = registry.recommend(controls.query, null, window.FleurySearchFormatCatalog).primary;
    if (/keilrahmenleisten|keilrahmen-set|stretcher\s+bars?|stretcher\s+frame\s+kit|barres?\s+de\s+ch[aâ]ssis|baguettes?\s+de\s+ch[aâ]ssis|listelli?\s+per\s+telai|kit\s+telaio/i.test(controls.query || '')) priority = 'bars';
    function familyRank(family) {
      var group = { gallery: 'canvas', studio: 'canvas', round: 'canvas', canvas: 'canvas', shadow: 'shadow', picture: 'picture', mat: 'mat', bars: 'bars' }[family];
      if (priority && group === (priority === 'kit' ? 'shadow' : priority)) return 0;
      return 1 + (['gallery', 'studio', 'shadow', 'bars', 'round', 'picture', 'mat', 'canvas'].indexOf(family) + 1 || 99);
    }
    filtered.sort(function (left, right) {
      var direction = controls.sort === 'price-desc' || controls.sort === 'title-desc' ? -1 : 1;
      if (controls.sort.indexOf('price-') === 0) return direction * (left.price - right.price) || left.product.title.localeCompare(right.product.title, locale);
      if (controls.sort.indexOf('title-') === 0) return direction * left.product.title.localeCompare(right.product.title, locale);
      return Number(right.available) - Number(left.available) || familyRank(left.family) - familyRank(right.family);
    });
    return filtered;
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function exactProductCard(entry, query) {
    var product = entry.product;
    var productTitle = localizedProductTitle(product);
    var card = element('li', 'snize-product fa-exact-product');
    card.dataset.faExactCard = 'true';
    card.lang = locale;
    var link = element('a', 'snize-view-link');
    var productUrl = rootUrl + 'products/' + encodeURIComponent(localizedHandleFor(product.handle));
    link.href = productUrl;
    var inner = element('div', 'snize-item');
    var thumbnail = element('div', 'snize-thumbnail');
    var imageUrl = product.featured_image || product.images && product.images[0];
    if (imageUrl && typeof imageUrl === 'object') imageUrl = imageUrl.src;
    if (imageUrl) {
      var image = element('img'); image.src = imageUrl; image.alt = productTitle; image.loading = 'lazy'; image.width = 480; image.height = 360; thumbnail.appendChild(image);
    }
    inner.appendChild(thumbnail);
    var content = element('div', 'snize-overhidden');
    var title = element('span', 'snize-title', productTitle); title.title = productTitle; content.appendChild(title);
    var prices = element('div', 'snize-price-list'); prices.appendChild(element('span', 'snize-price')); content.appendChild(prices);
    inner.appendChild(content); link.appendChild(inner); card.appendChild(link);
    enhanceCard(card, product, productUrl, query, entry.variants);
    return card;
  }

  function updateExactUrl(form, reset) {
    var url = new URL(window.location.href);
    ['fa_price_min', 'fa_price_max', 'fa_sort'].forEach(function (key) {
      var field = form.querySelector('[name="' + key + '"]');
      var value = !reset && field ? field.value.trim() : '';
      if (value && !(key === 'fa_sort' && value === 'relevance')) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    if (window.history && window.history.replaceState) window.history.replaceState(null, '', url.toString());
    else window.location.assign(url.toString());
    renderExactResults();
  }

  function makeExactToolbar(controls) {
    var copy = interfaceCopy[locale];
    var toolbar = element('form', 'fa-exact-toolbar');
    toolbar.setAttribute('aria-label', actions[locale].filter);
    [['fa_price_min', copy.minimum, controls.minimum], ['fa_price_max', copy.maximum, controls.maximum]].forEach(function (item) {
      var label = element('label', 'fa-exact-price-label', item[1]);
      var input = element('input'); input.type = 'number'; input.name = item[0]; input.min = '0'; input.step = '0.01'; input.inputMode = 'decimal';
      input.value = item[2] !== null && Number.isFinite(item[2]) ? String(item[2] / 100) : '';
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'CHF';
      input.setAttribute('aria-label', item[1] + ' (' + currency + ')'); label.appendChild(input); toolbar.appendChild(label);
    });
    var submit = element('button', 'fa-exact-apply', copy.apply); submit.type = 'submit'; toolbar.appendChild(submit);
    var reset = element('button', 'fa-exact-reset', copy.reset); reset.type = 'button'; toolbar.appendChild(reset);
    reset.addEventListener('click', function () { updateExactUrl(toolbar, true); });
    var sortLabel = element('label', 'fa-exact-sort-label', copy.sort);
    var select = element('select'); select.name = 'fa_sort'; select.setAttribute('aria-label', copy.sort);
    [copy.relevance, copy.ascending, copy.descending, copy.titleAsc, copy.titleDesc].forEach(function (label, index) {
      var option = element('option', '', label); option.value = exactSortValues[index]; select.appendChild(option);
    });
    select.value = controls.sort; sortLabel.appendChild(select); toolbar.appendChild(sortLabel);
    select.addEventListener('change', function () { updateExactUrl(toolbar, false); });
    toolbar.addEventListener('submit', function (event) { event.preventDefault(); updateExactUrl(toolbar, false); });
    return toolbar;
  }

  function renderExactResults() {
    var state = exactState;
    if (!state || !state.mount) return;
    var controls = readExactControls(window.location.href);
    controls.query = state.query;
    var key = JSON.stringify([state.query, state.status, state.revision || 0, controls]);
    if (state.mount.dataset.renderKey === key) return;
    state.mount.dataset.renderKey = key;
    state.mount.textContent = '';
    state.mount.setAttribute('aria-busy', String(state.status === 'loading'));
    var copy = interfaceCopy[locale];
    if (state.status !== 'ready') {
      var status = element('p', 'fa-exact-status', state.status === 'loading' ? copy.loading : copy.loadError);
      status.setAttribute('role', state.status === 'loading' ? 'status' : 'alert'); state.mount.appendChild(status);
      if (state.status === 'error') {
        var retry = element('button', 'fa-exact-retry', copy.retry); retry.type = 'button';
        retry.addEventListener('click', function () {
          state.candidates.forEach(function (candidate) { productCache.delete(localizedHandleFor(candidate.handle)); });
          loadExactProducts(state);
        }); state.mount.appendChild(retry);
      }
      return;
    }
    var filtered = filterExactProducts(state.products, controls);
    var summary = element('p', 'fa-search-results-summary fa-exact-summary'); summary.setAttribute('aria-live', 'polite');
    summary.textContent = controls.valid ? filtered.length + ' ' + (filtered.length === 1 ? exactSingleCopy[locale] : copy.exact) + ' ' + actions[locale].for + ' „' + state.query + '“' : copy.priceError;
    state.mount.appendChild(summary);
    state.mount.appendChild(makeExactToolbar(controls));
    if (!controls.valid) return;
    if (!filtered.length) {
      var empty = element('p', 'fa-exact-empty', state.products.length ? copy.emptyPrice : copy.empty); empty.setAttribute('role', 'status'); state.mount.appendChild(empty);
      return;
    }
    var grid = element('ul', 'snize-search-results-content fa-exact-grid');
    filtered.forEach(function (entry) { grid.appendChild(exactProductCard(entry, state.query)); });
    state.mount.appendChild(grid);
  }

  function loadExactProducts(state) {
    state.status = 'loading'; renderExactResults();
    var requestId = ++exactRequest;
    Promise.all(state.candidates.map(function (candidate) {
      return localizedProduct(candidate.handle).then(function (product) {
        if (!product) throw new Error('incomplete');
        var variants = matchingExactVariants(product, candidate, state.intent);
        return variants.length ? { product: product, variants: variants, family: candidate.family } : null;
      });
    })).then(function (products) {
      if (exactState !== state || requestId !== exactRequest || searchQuery() !== state.query) return;
      state.products = products.filter(Boolean); state.status = 'ready'; state.revision = (state.revision || 0) + 1; renderExactResults();
    }).catch(function () {
      if (exactState !== state || requestId !== exactRequest || searchQuery() !== state.query) return;
      state.status = 'error'; renderExactResults();
    });
  }

  function syncExactResults() {
    var page = document.querySelector('[data-fa-search-page]');
    if (!page) return false;
    var parser = window.FleurySearchFormatIntent;
    var query = searchQuery();
    var intent = parser && parser.parseFormatIntent(query);
    var native = document.getElementById('snize_results');
    if (!intent) {
      if (page.dataset.faExactMode === 'true') { delete page.dataset.faExactMode; if (native) delete native.dataset.faExactMode; }
      if (exactState) { exactState.mount.remove(); exactState = null; exactRequest += 1; }
      return false;
    }
    page.dataset.faExactMode = 'true';
    if (native) native.dataset.faExactMode = 'true';
    var mount = document.getElementById('fa-search-exact-results');
    if (!mount) {
      mount = element('div', 'snize fa-search-exact'); mount.id = 'fa-search-exact-results'; mount.dataset.faExactResults = ''; mount.lang = locale;
      var recommendations = page.querySelector('[data-fa-search-recommendations]');
      if (recommendations && recommendations.parentNode) recommendations.parentNode.insertBefore(mount, recommendations);
      else if (native && native.parentNode) native.parentNode.insertBefore(mount, native);
      else page.appendChild(mount);
    }
    if (!exactState || exactState.query !== query) {
      exactState = { query: query, intent: intent, mount: mount, candidates: exactCandidates(window.FleurySearchFormatCatalog, intent), status: 'loading' };
      loadExactProducts(exactState);
    } else {
      exactState.mount = mount;
      renderExactResults();
    }
    return true;
  }

  function scan() {
    installFormatQueryHistoryGuard();
    preserveCommittedFormatQuery();
    var searchInput = document.querySelector('[data-fa-search-query]');
    if (searchInput && !searchInput.dataset.faInitialized) {
      searchInput.value = searchQuery();
      searchInput.dataset.faInitialized = 'true';
      // Keep the unpublished preview selected during form-based QA.
      ['view', 'preview_theme_id'].forEach(function (key) {
        var value = new URL(window.location.href).searchParams.get(key);
        if (!value) return;
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = key; hidden.value = value;
        searchInput.form.appendChild(hidden);
      });
    }
    var exact = syncExactResults();
    document.querySelectorAll('li.snize-product').forEach(function (card) { if (!(exact && card.closest('#snize_results'))) localizeCard(card); });
    document.querySelectorAll('#snize_results, #snize-instant-search-results, #snize-modal-mobile-filters-dialog, #snize-modal-mobile-sortby-dialog').forEach(localizeText);
    document.querySelectorAll('.snize-modal .snize-close-button').forEach(function (button) { button.setAttribute('aria-label', actions[locale].close); });
    hideForbiddenFilters();
    hideContentTabs();
    localizeInstantActions();
    if (!exact) enhanceToolbar();
  }

  function scheduleScan() {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(scan, 40);
  }

  function preserveSearchReturnTo(event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('select[name="language_code"]')) return;
    var form = select.closest('form');
    if (!form || form.id !== 'FleuryHeaderLanguageForm') return;
    var current = new URL(window.location.href);
    if (!/^\/(?:de\/|en\/|fr\/|it\/)?pages\/search-results-page\/?$/.test(current.pathname)) return;
    var returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) return;
    // Searchanise changes the URL without re-rendering this Liquid form. Use
    // the committed result URL, never the possibly unfinished instant query.
    // Shopify's localization endpoint applies the selected locale prefix.
    var destination = current.pathname + current.search + current.hash;
    if (returnTo.value !== destination) returnTo.value = destination;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();

  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
  if (window.addEventListener) window.addEventListener('popstate', onSearchPopstate);
  document.addEventListener('input', scheduleScan);
  // Capture runs before the select's inline onchange="this.form.submit()".
  document.addEventListener('change', preserveSearchReturnTo, true);
})();
